/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  document.addEventListener('change', function(e) {
    var input = e.target;
    if (input.type === 'radio' && input.name && input.name.indexOf('options') === 0) {
      var wrapper = input.closest('.selector-wrapper') || input.closest('[data-option-position]');
      if (wrapper) {
        var valueEl = wrapper.querySelector('.radio__legend__value[data-option-value]') || wrapper.querySelector('[data-option-value]');
        if (valueEl) valueEl.textContent = input.checked ? input.value : '';
      }
    }
  });

  // Custom arrow slider for collection list 
  function collectionListSlider() {
    const sliderSections = document.querySelectorAll('[data-custom-slider-container]');
    
    sliderSections.forEach((section) => {
      const slider = section.querySelector('[data-grid-slider]');
      const prevBtn = section.querySelector('[data-custom-arrow-prev]');
      const nextBtn = section.querySelector('[data-custom-arrow-next]');

      if (!slider || !prevBtn || !nextBtn) return;

      let lastClickTime = 0;
      const throttleDelay = 500; 

      const updateArrowState = () => {
        const scrollLeft = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        
        prevBtn.disabled = scrollLeft <= 10;
        nextBtn.disabled = scrollLeft >= maxScroll - 10;
      };

      const getScrollStep = () => {
        const firstItem = slider.querySelector('.grid-item, .collection-item, [class*="item"]');
        return firstItem ? firstItem.offsetWidth : slider.clientWidth / 2;
      };

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const now = Date.now();
        if (now - lastClickTime < throttleDelay) return;
        lastClickTime = now;
        slider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const now = Date.now();
        if (now - lastClickTime < throttleDelay) return;
        lastClickTime = now;
        slider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      
      setTimeout(updateArrowState, 500);
    });
  }

  function initHeaderState() {
  const header = document.querySelector('header-component');
  const drawerBody = document.querySelector('.drawer__body');
  const announcementBar = document.querySelector('announcement-bar');
  const drawer = document.querySelector('.drawer');
  
  let isStuck = false;
  let isMobile = window.innerWidth < 750;
  let isDrawerOpen = false;
  
  if (!header || !isMobile) return;
  
  function updateState() {
    if (!isMobile || !drawerBody) return;
    isStuck = header.classList.contains('js__header__stuck');
  }
  
  function getAnnouncementBarHeight() {
    if (!announcementBar || !isMobile) return 0;
    if (isStuck) return 0;
    
    const rect = announcementBar.getBoundingClientRect();
    return rect.height;
  }
  
  function updateDrawerMargin() {
    if (!isMobile) return;
    const announcementHeight = getAnnouncementBarHeight();
    const baseMargin = 0;
    const totalMargin = baseMargin + announcementHeight;
    
    drawerBody.style.marginTop = `${totalMargin}px`;
  }
  
  function updateTextColor() {
    if (!isMobile || !announcementBar) return;
    
    if (isDrawerOpen) {
      announcementBar.classList.add('drawer-open');
    } else {
      announcementBar.classList.remove('drawer-open');
    }
  }
  
  // Initial setup
  updateState();
  updateDrawerMargin();
  
  // Observe header class changes
  const observer = new MutationObserver(() => {
    if (!isMobile) return;
    updateState();
    updateDrawerMargin();
  });
  
  observer.observe(header, {
    attributes: true,
    attributeFilter: ['class']
  });
  
  // Observe drawer open/close state
  if (drawer) {
    const drawerObserver = new MutationObserver(() => {
      if (!isMobile) return;
      isDrawerOpen = drawer.classList.contains('is-open'); // FIXED: now correctly checks 'is-open'
      updateTextColor();
    });
    
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Scroll event
  window.addEventListener('scroll', () => {
    if (!isMobile) return;
    updateState();
    updateDrawerMargin();
  });
  
  // Resize event
  window.addEventListener('resize', () => {
    isMobile = window.innerWidth < 750;
    if (!isMobile) {
      drawerBody.style.marginTop = '0px';
      if (announcementBar) announcementBar.classList.remove('drawer-open');
      return;
    }
    updateState();
    updateDrawerMargin();
    updateTextColor();
  });
}
  function sizeGuideHideSwitcherIfEmpty() {
    var guides = document.querySelectorAll('.drawer--size-guide');
    guides.forEach(function(popup) {
      var switcher = popup.querySelector('[data-size-guide-switcher]');
      if (!switcher) return;
      var tables = popup.querySelectorAll('table');
      var hasConvertible = false;
      tables.forEach(function(table) {
        if (hasConvertible) return;
        var rows = table.querySelectorAll('tr');
        rows.forEach(function(row) {
          if (hasConvertible) return;
          var cells = row.querySelectorAll('td, th');
          cells.forEach(function(cell) {
            if (hasConvertible) return;
            var text = (cell.textContent || '').trim();
            if (/\bcm\b/i.test(text) || /\d\s*cm\b/i.test(text)) {
              hasConvertible = true;
            }
          });
        });
      });
      if (!hasConvertible) {
        switcher.style.display = 'none';
      }
    });
  }

  function sizeGuideFixMobileScroll() {
    document.querySelectorAll('.drawer--size-guide .drawer__body').forEach(function(body) {
      body.addEventListener('touchmove', function(e) {
        e.stopPropagation();
      }, { passive: true });
    });
  }

  function sizeGuideUnitSwitcher() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-size-guide-unit]');
      if (!btn) return;

      var guide = btn.closest('[data-size-guide]');
      var switcher = guide ? guide.querySelector('[data-size-guide-switcher]') : null;
      var popup = guide ? guide.closest('.drawer--size-guide') : null;
      if (!switcher || !popup) return;

      var unit = btn.getAttribute('data-size-guide-unit');
      var buttons = switcher.querySelectorAll('[data-size-guide-unit]');
      var tables = popup.querySelectorAll('table');

      buttons.forEach(function(b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      // Parse tables on first interaction
      if (!popup.hasAttribute('data-sg-parsed')) {
        popup.setAttribute('data-sg-parsed', 'true');

        tables.forEach(function(table) {
          var rows = table.querySelectorAll('tr');

          rows.forEach(function(row) {
            var cells = row.querySelectorAll('td, th');
            if (cells.length < 2) return;

            var labelCell = cells[0];
            var labelText = (labelCell.textContent || '').toLowerCase();
            // Row label contains "cm" (e.g. "Waist (cm)")
            var isCmRow = /\bcm\b/.test(labelText) || labelText.indexOf('(cm)') !== -1;

            if (isCmRow) {
              labelCell.setAttribute('data-sg-label-original', labelCell.textContent);
            }

            for (var i = 1; i < cells.length; i++) {
              var cell = cells[i];
              var text = cell.textContent.trim();
              var cleanText = text.replace(/\s*cm\s*/gi, '').trim();
              // Check if this individual cell contains "cm" (e.g. "75 cm")
              var cellHasCm = /\d\s*cm\b/i.test(text);

              if (isCmRow || cellHasCm) {
                if (/^\d+(\.\d+)?\s*[-–]\s*\d+(\.\d+)?$/.test(cleanText)) {
                  cell.setAttribute('data-sg-convertible', 'true');
                  cell.setAttribute('data-sg-original', cleanText);
                  cell.setAttribute('data-sg-type', 'range');
                  // Store original display text to restore with "cm" suffix
                  cell.setAttribute('data-sg-display', text);
                } else if (/^\d+(\.\d+)?$/.test(cleanText)) {
                  cell.setAttribute('data-sg-convertible', 'true');
                  cell.setAttribute('data-sg-original', cleanText);
                  cell.setAttribute('data-sg-type', 'single');
                  cell.setAttribute('data-sg-display', text);
                } else {
                  cell.setAttribute('data-sg-convertible', 'false');
                }
              } else {
                cell.setAttribute('data-sg-convertible', 'false');
              }
            }
          });
        });
      }

      // Convert values
      var convertibleCells = popup.querySelectorAll('[data-sg-convertible="true"]');
      convertibleCells.forEach(function(cell) {
        var original = cell.getAttribute('data-sg-original');
        var display = cell.getAttribute('data-sg-display') || original;
        var type = cell.getAttribute('data-sg-type');

        if (unit === 'in') {
          if (type === 'range') {
            var parts = original.split(/\s*[-–]\s*/);
            var low = Math.round((parseFloat(parts[0]) / 2.54) * 10) / 10;
            var high = Math.round((parseFloat(parts[1]) / 2.54) * 10) / 10;
            cell.textContent = low + ' - ' + high;
          } else {
            cell.textContent = Math.round((parseFloat(original) / 2.54) * 10) / 10;
          }
        } else {
          cell.textContent = display;
        }
      });

      // Update row labels (cm ↔ in)
      var labelCells = popup.querySelectorAll('[data-sg-label-original]');
      labelCells.forEach(function(labelCell) {
        var originalLabel = labelCell.getAttribute('data-sg-label-original');

        if (unit === 'in') {
          labelCell.textContent = originalLabel.replace(/cm/gi, 'in');
        } else {
          labelCell.textContent = originalLabel;
        }
      });
    });
  }


  function updateCartItemLabel() {
    const heading = document.querySelector('.drawer--cart .drawer__heading');
    if (!heading) return;
    const countEl = heading.querySelector('.cart__items-count');
    if (!countEl) return;

    const count = parseInt(countEl.textContent, 10);
    if (isNaN(count)) return;

    const label = count === 1
      ? heading.getAttribute('data-item-label-one')
      : heading.getAttribute('data-item-label-other');

    var textNode = countEl.nextSibling;
    if (textNode && textNode.nodeType === 3) {
      textNode.textContent = '\n        ' + label + '\n      ';
    }
  }

  function observeCartItemLabel() {
    updateCartItemLabel();

    document.addEventListener('theme:cart:change', updateCartItemLabel);
    document.addEventListener('theme:product:added', updateCartItemLabel);

    var drawer = document.querySelector('.drawer--cart');
    if (drawer) {
      new MutationObserver(updateCartItemLabel)
        .observe(drawer, { childList: true, subtree: true });
    }
  }

  function siblingsOverflowToggle() {
    document.querySelectorAll('[data-siblings-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var container = btn.closest('[data-siblings-collapsible]');
        if (container) {
          container.classList.add('is-expanded');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function quickAddSliderSync() {
    /* Re-init slider after quick-add dialog opens (Flickity needs visible element) */
    document.addEventListener('theme:quick-add:open', function() {
      setTimeout(function() {
        var dialogs = document.querySelectorAll('dialog[data-quick-add-modal][open]');
        dialogs.forEach(function(dialog) {
          var slider = dialog.querySelector('slider-component.product-quick-add__slider');
          if (slider) {
            if (slider.flkty) {
              slider.flkty.resize();
            } else {
              slider.dispatchEvent(new CustomEvent('theme:slider:init'));
            }
          }
        });
      }, 300);
    });

    /* Navigate slider to variant image on variant change */
    document.addEventListener('theme:variant:change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.featured_media) return;

      var modal = e.target.closest('[data-quick-add-modal]');
      if (!modal) return;

      var slider = modal.querySelector('slider-component.product-quick-add__slider');
      if (!slider || !slider.flkty) return;

      var mediaId = String(variant.featured_media.id);
      var slides = slider.querySelectorAll('[data-slide]');

      slides.forEach(function(slide, index) {
        var slideMediaId = slide.getAttribute('data-media-id') || '';
        if (slideMediaId.endsWith('-' + mediaId)) {
          slider.flkty.select(index);
        }
      });
    });
  }

  function klaviyoFormTrigger() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-klaviyo-form-trigger]');
      if (!btn) return;
      e.preventDefault();
      var formId = btn.getAttribute('data-klaviyo-form-trigger');
      if (!formId) return;

      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm(formId);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      }
    });
  }

  function initCartBarBehavior() {
    if (!document.body.classList.contains('template-product')) return;

    var productComponent = document.querySelector('product-component');
    if (!productComponent || !productComponent.cartBar) return;

    var cartBar = productComponent.cartBar;
    var form = productComponent.form;
    if (!form) return;

    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    if (!addToCartBtn) return;

    // Remove the theme's built-in scroll toggle so it doesn't conflict
    document.removeEventListener('theme:scroll', productComponent.toggleCartBarOnScroll);

    // Show cart bar only after scrolling past the ATC button (not before it)
    document.addEventListener('theme:scroll', function() {
      var rect = addToCartBtn.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      cartBar.classList.toggle('is-visible', scrolledPast);
    });

    // Hide cart bar when it overlaps the footer
    window.addEventListener('scroll', function() {
      var footer = document.querySelector('.footer-sections');
      if (!footer) return;
      var footerTop = footer.getBoundingClientRect().top;
      var overLap = window.innerHeight - footerTop;

      if (overLap > 0) {
        cartBar.style.opacity = '0';
        cartBar.style.transition = 'opacity .3s ease';
        cartBar.style.pointerEvents = 'none';
      } else {
        cartBar.style.opacity = '';
        cartBar.style.transition = '';
        cartBar.style.pointerEvents = '';
      }
    }, { passive: true });

    // Black background on cart bar button when the main ATC button is enabled
    function updateCartBarStyle() {
      var isEnabled = !addToCartBtn.disabled;
      cartBar.classList.toggle('cart-bar--active', isEnabled);
    }

    var styleObserver = new MutationObserver(updateCartBarStyle);
    styleObserver.observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
    updateCartBarStyle();
  }

  // Cart upsell recommendations — fetches Shopify Product Recommendations
  // for each cart product and injects them into the upsell grid-slider
  function cartUpsellRecommendations() {
    var containers = document.querySelectorAll('[data-upsell-recommendations]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      fetchRecommendationsForContainer(container);
    });

    // Re-fetch when cart changes (add/remove items)
    document.addEventListener('theme:cart:change', function() {
      fetch(window.theme.routes.cart_url + '.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var ids = [];
          var seen = {};
          cart.items.forEach(function(item) {
            if (!seen[item.product_id]) {
              seen[item.product_id] = true;
              ids.push(item.product_id);
            }
          });

          containers.forEach(function(container) {
            container.setAttribute('data-cart-product-ids', ids.join(','));
            var slider = container.querySelector('[data-grid-slider]');
            if (slider) {
              // Remove dynamically added recommendation items (keep static ones)
              slider.querySelectorAll('[data-recommendation-added]').forEach(function(el) {
                el.remove();
              });
            }
            fetchRecommendationsForContainer(container);
          });
        });
    });
  }

  function fetchRecommendationsForContainer(container) {
    var idsAttr = container.getAttribute('data-cart-product-ids');
    if (!idsAttr) return;

    var productIds = idsAttr.split(',').map(function(id) { return id.trim(); }).filter(Boolean);
    if (!productIds.length) return;

    var limit = parseInt(container.getAttribute('data-recommendations-limit'), 10) || 4;
    var slider = container.querySelector('[data-grid-slider]');
    if (!slider) return;

    var recsUrl = window.theme.routes.product_recommendations_url;
    if (!recsUrl) return;

    var fetches = productIds.map(function(id) {
      return fetch(recsUrl + '?product_id=' + id + '&section_id=api-cart-recommendations')
        .then(function(res) { return res.text(); });
    });

    Promise.all(fetches).then(function(texts) {
      var fragment = document.createDocumentFragment();
      var seenIds = {};
      var count = 0;

      // Collect existing product IDs already in the slider (static products)
      slider.querySelectorAll('[data-quick-add-holder]').forEach(function(el) {
        var existingId = el.getAttribute('data-quick-add-holder');
        if (existingId) seenIds[existingId] = true;
      });

      // Also exclude cart products from recommendations
      productIds.forEach(function(id) { seenIds[id] = true; });

      // Exclude complementary products already shown in cart
      document.querySelectorAll('[data-cart-complementary-item]').forEach(function(el) {
        var compId = el.getAttribute('data-cart-complementary-item');
        if (compId) seenIds[compId] = true;
      });

      texts.forEach(function(html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        var results = div.querySelector('[data-results]');
        if (!results) return;

        results.querySelectorAll('quick-add-product').forEach(function(el) {
          if (count >= limit) return;
          var holder = el.querySelector('[data-quick-add-holder]');
          if (!holder) return;

          var productId = holder.getAttribute('data-quick-add-holder');
          if (seenIds[productId]) return;

          seenIds[productId] = true;
          count++;
          el.setAttribute('data-recommendation-added', '');
          fragment.appendChild(el);
        });
      });

      if (fragment.children.length > 0) {
        slider.appendChild(fragment);
      }

      // Re-initialize the slider arrows for the updated content
      collectionListSlider();
    });
  }

  // Dynamic bundle bar update — re-fetches bundle info when cart changes
  function observeBundleBarUpdates() {
    var bundleHolder = document.querySelector('[data-bundle-holder]');
    if (!bundleHolder) return;

    document.addEventListener('theme:cart:change', function() {
      fetch(window.theme.routes.cart_url + '?section_id=api-cart-bundle')
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var div = document.createElement('div');
          div.innerHTML = html;
          var apiBundleBar = div.querySelector('[data-api-cart-bundle]');
          if (apiBundleBar) {
            bundleHolder.innerHTML = apiBundleBar.innerHTML;
          }
        });
    });
  }

  function roundFreeShippingDisplay() {
    document.querySelectorAll('[data-left-to-spend]').forEach(function(el) {
      var text = el.textContent;
      el.textContent = text.replace(/([\d.,]+)/, function(match) {
        var cleaned = match.replace(/[^\d.,]/g, '');
        var separator = cleaned.indexOf(',') > cleaned.indexOf('.') ? ',' : '.';
        var parts = cleaned.split(separator);
        if (parts.length === 2 && parts[1] !== '00' && parts[1] !== '') {
          var whole = parseInt(parts[0].replace(/[^\d]/g, ''), 10) + 1;
          var thousandSep = separator === ',' ? '.' : ',';
          var formatted = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
          return formatted;
        }
        return match.replace(/[.,]00$/, '');
      });
    });
  }

  function fixFreeShippingLocalLimit() {
    var freeShippingEls = document.querySelectorAll('[data-free-shipping][data-free-shipping-local]');
    if (!freeShippingEls.length) return;

    var limit = Number(freeShippingEls[0].getAttribute('data-free-shipping-limit'));
    if (!limit) return;

    var limitCents = limit * 100;
    var cartComponent = document.querySelector('cart-items');
    if (cartComponent && cartComponent.freeShippingLimit !== limitCents) {
      cartComponent.freeShippingLimit = limitCents;
      if (typeof cartComponent.updateProgress === 'function') {
        cartComponent.updateProgress();
      }
      if (typeof cartComponent.freeShippingMessageHandle === 'function') {
        cartComponent.freeShippingMessageHandle(cartComponent.subtotal);
      }
    }
    roundFreeShippingDisplay();
  }

  function fixFreeShippingDisplay() {
    var cartComponent = document.querySelector('cart-items');
    if (cartComponent) {
      roundFreeShippingDisplay();
    }
  }

  document.addEventListener('theme:cart:change', function() {
    fixFreeShippingLocalLimit();
    setTimeout(fixFreeShippingDisplay, 100);
  });
  document.addEventListener('theme:product:added', function() {
    fixFreeShippingLocalLimit();
    setTimeout(fixFreeShippingDisplay, 100);
  });

  /**
   * Remove orphaned free gift items from cart when the free gift feature is disabled.
   * When enabled, free-gift.js handles add/remove. This covers the case where the
   * feature is turned off while a customer still has the gift in their cart.
   */
  function removeOrphanedFreeGifts() {
    if (window.freeGiftConfig && window.freeGiftConfig.enabled) return;

    fetch(window.theme.routes.cart_url + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then((r) => r.json())
      .then((cart) => {
        const updates = {};
        let hasOrphans = false;

        cart.items.forEach((item) => {
          if (item.properties && item.properties._is_free_gift === 'true') {
            updates[item.key] = 0;
            hasOrphans = true;
          }
        });

        if (!hasOrphans) return;

        return fetch(window.theme.routes.cart_update_url + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        }).then(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        });
      })
      .catch(() => {});
  }

  function anchorScrollLinks() {
    var links = document.querySelectorAll('[data-scroll-target]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var selector = link.getAttribute('data-scroll-target');
        var target = document.querySelector(selector);
        if (!target) return;

        e.preventDefault();
        window.theme.scrollTo(target.getBoundingClientRect().top);
      });
    });
  }

  function fixMobileSliderTouch() {
    var sliders = document.querySelectorAll('.sliderule-grid--slider');
    if (!sliders.length) return;

    sliders.forEach(function(slider) {
      slider.addEventListener('touchmove', function(e) {
        e.stopPropagation();
      }, { passive: true });
    });
  }

  /* ---- Siblings Length: Quick-Add on Collection Grid ---- */
  function siblingsLengthQuickAdd() {

    function getSiblingsData(hover) {
      var el = hover.querySelector('[data-siblings-length-json]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (err) {
        return null;
      }
    }

    function getSelectedOptions(hover) {
      var opts = {};
      hover.querySelectorAll('[data-option-position]').forEach(function(block) {
        var pos = block.getAttribute('data-option-position');
        if (pos === 'length') return;
        var selected = block.querySelector('[data-quick-add-option-value][aria-pressed="true"], [data-quick-add-option-value].is-selected');
        if (selected) opts[pos] = selected.getAttribute('data-quick-add-option-value');
      });
      return opts;
    }

    function getSelectedSiblingHandle(hover) {
      var btn = hover.querySelector('[data-siblings-length-btn][aria-pressed="true"]');
      return btn ? btn.getAttribute('data-siblings-length-handle') : null;
    }

    function addSiblingVariant(hover, handle, selectedOptions) {
      var siblingsData = getSiblingsData(hover);
      if (!siblingsData || !siblingsData[handle]) return;

      var siblingInfo = siblingsData[handle];
      var option1 = selectedOptions['1'] || null;
      if (!option1) return;

      var matchedVariant = null;
      for (var i = 0; i < siblingInfo.variants.length; i++) {
        var v = siblingInfo.variants[i];
        if (v.option1 === option1 && v.available) {
          matchedVariant = v;
          break;
        }
      }

      if (!matchedVariant) return;

      var form = hover.querySelector('form');
      var variantInput = form ? form.querySelector('[data-quick-add-variant-id]') : null;
      if (!form || !variantInput) return;

      variantInput.value = matchedVariant.id;
      variantInput.name = 'id';

      var triggerBtn = form.querySelector('[data-quick-add-trigger]');
      if (triggerBtn) {
        /* Mark this hover container for reset after add */
        hover.setAttribute('data-siblings-pending-reset', '');

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: { button: triggerBtn },
            bubbles: true,
          })
        );
      }
    }

    /* Handle length button click */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-siblings-length-btn]');
      if (!btn) return;

      var hover = btn.closest('[data-quick-add-hover]');
      if (!hover) return;

      e.preventDefault();

      var handle = btn.getAttribute('data-siblings-length-handle');
      if (!handle) return;

      /* Mark this length button as selected */
      hover.querySelectorAll('[data-siblings-length-btn]').forEach(function(b) {
        var isSelected = b === btn;
        b.setAttribute('aria-pressed', isSelected);
        b.classList.toggle('is-selected', isSelected);
      });

      var selectedOptions = getSelectedOptions(hover);
      addSiblingVariant(hover, handle, selectedOptions);
    });

    /* Handle size button click: enable length step + submit if sibling already selected */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add-option-value]');
      if (!btn) return;

      var hover = btn.closest('[data-quick-add-hover]');
      if (!hover) return;

      var lengthStep = hover.querySelector('[data-siblings-length-step]');
      if (!lengthStep) return;

      /* Enable the length step once a size is selected */
      setTimeout(function() {
        var selectedOptions = getSelectedOptions(hover);
        if (selectedOptions['1']) {
          lengthStep.classList.remove('is-disabled');
        }

        var siblingHandle = getSelectedSiblingHandle(hover);
        if (siblingHandle) {
          addSiblingVariant(hover, siblingHandle, selectedOptions);
        }
      }, 10);
    });

    /* Reset length step after product is added to cart */
    document.addEventListener('theme:product:added', function() {
      var pendingHovers = document.querySelectorAll('[data-siblings-pending-reset]');
      pendingHovers.forEach(function(hover) {
        hover.removeAttribute('data-siblings-pending-reset');

        var lengthStep = hover.querySelector('[data-siblings-length-step]');
        if (lengthStep) {
          lengthStep.classList.add('is-disabled');
        }

        /* Deselect all length buttons, re-select current product */
        hover.querySelectorAll('[data-siblings-length-btn]').forEach(function(b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });

        /* Deselect all size buttons */
        hover.querySelectorAll('[data-quick-add-option-value]').forEach(function(b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('is-selected');
        });
      });
    });
  }

  /* ---- Siblings Length: Preserve selected options across sibling navigation ---- */
  function siblingsLengthPreserveOptions() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a.siblings-length__btn');
      if (!link) return;

      var block = link.closest('.product__block--siblings-length');
      if (!block) return;

      e.preventDefault();

      var section = block.closest('[data-section-type]') || document;
      var url = new URL(link.href, window.location.origin);

      section.querySelectorAll('[name^="options"]:checked').forEach(function(input) {
        if (!input.value) return;
        var match = input.name.match(/^options\[([^\]]+)\]/);
        if (match) url.searchParams.set('slopt_' + match[1], input.value);
      });

      window.location.href = url.toString();
    });
  }

  function siblingsLengthApplyUrlOptions() {
    var params = new URLSearchParams(window.location.search);
    var hasOptions = false;

    params.forEach(function(_, key) {
      if (key.indexOf('slopt_') === 0) hasOptions = true;
    });
    if (!hasOptions) return;

    requestAnimationFrame(function() {
      var cleanUrl = new URL(window.location.href);

      params.forEach(function(value, key) {
        if (key.indexOf('slopt_') !== 0 || !value) return;
        var optName = key.substring(6);
        cleanUrl.searchParams.delete(key);

        document.querySelectorAll('input[type="radio"][name^="options[' + optName + ']"]').forEach(function(radio) {
          if (radio.value === value) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            var label = document.querySelector('label[for="' + radio.id + '"]');
            if (label) label.click();
          }
        });
      });

      window.history.replaceState({}, '', cleanUrl.toString());
    });
  }

  /* ---- Siblings Length: Quick-Add Modal reload ---- */
  function siblingsLengthModal() {
    document.addEventListener('change', function(e) {
      var input = e.target.closest('[data-siblings-length-modal-btn]');
      if (!input) return;

      var handle = input.getAttribute('data-siblings-length-modal-handle');
      if (!handle) return;

      /* Don't reload if already on this product */
      if (input.checked && input.defaultChecked) return;

      /* Find the current modal */
      var modal = input.closest('[data-quick-add-modal]');
      if (!modal) return;

      var ajaxContainer = modal.querySelector('[data-product-upsell-ajax]');
      if (!ajaxContainer) return;

      /* Show loading state */
      ajaxContainer.style.opacity = '0.5';

      /* Fetch the sibling product's modal content */
      var rootUrl = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      fetch(rootUrl + 'products/' + handle + '?section_id=api-product-upsell')
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          /* Use the exact same parsing approach as the theme's modalCreate */
          var parsedContent = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-api-content]');

          if (parsedContent) {
            /* Disconnect old custom elements cleanly */
            var oldCustomEls = ajaxContainer.querySelectorAll('product-form, slider-component, popout-select');
            oldCustomEls.forEach(function(el) { el.remove(); });

            /* Set new content */
            ajaxContainer.innerHTML = parsedContent.innerHTML;
            /* Trigger animations on new elements (same as modalOpen) */
            requestAnimationFrame(function() {
              ajaxContainer.querySelectorAll('[data-animation]').forEach(function(item) {
                item.classList.add('is-animated');
              });
            });          }

          ajaxContainer.style.opacity = '';
        })
        .catch(function() {
          ajaxContainer.style.opacity = '';
        });
    });
  }

  function initCompOptionSliders() {
    function updateScrollClasses(el) {
      var isOverflowing = el.scrollWidth > el.clientWidth + 1;
      el.classList.toggle('is-overflowing', isOverflowing);
      if (!isOverflowing) {
        el.classList.remove('is-scrolled-start', 'is-scrolled-middle', 'is-scrolled-end');
        return;
      }
      var atStart = el.scrollLeft < 2;
      var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
      el.classList.toggle('is-scrolled-start', atStart && !atEnd);
      el.classList.toggle('is-scrolled-end', atEnd && !atStart);
      el.classList.toggle('is-scrolled-middle', !atStart && !atEnd);
    }

    function setup() {
      var containers = document.querySelectorAll('.cart-comp__option-values');
      containers.forEach(function(el) {
        updateScrollClasses(el);
        el.addEventListener('scroll', function() { updateScrollClasses(el); }, { passive: true });
      });
    }

    setup();
    document.addEventListener('theme:cart:refresh', function() {
      setTimeout(setup, 500);
    });
  }

  function initCompVariantSelectors() {
    var submittingCards = {};
    var touchStartX = 0;
    var touchMoved = false;

    document.addEventListener('touchstart', function(e) {
      if (e.target.closest('.cart-comp__option-values')) {
        touchStartX = e.touches[0].clientX;
        touchMoved = false;
      }
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (e.target.closest('.cart-comp__option-values')) {
        if (Math.abs(e.touches[0].clientX - touchStartX) > 8) {
          touchMoved = true;
        }
      }
    }, { passive: true });

    document.addEventListener('theme:cart:refresh', function() {
      setTimeout(function() { submittingCards = {}; }, 1000);
    });
    document.addEventListener('click', function(e) {
      var link = e.target.closest('[data-comp-option-value]');
      if (!link) return;
      e.preventDefault();

      if (touchMoved) {
        touchMoved = false;
        return;
      }

      var productId = link.getAttribute('data-comp-product-id');
      var card = link.closest('[data-cart-complementary-item]');
      if (!card) return;

      if (submittingCards[productId]) return;

      var group = link.closest('[data-comp-option-group]');
      if (group) {
        group.querySelectorAll('[data-comp-option-value]').forEach(function(el) {
          el.classList.remove('is-active');
        });
        link.classList.add('is-active');
      }

      var groups = card.querySelectorAll('[data-comp-option-group]');
      var selectedOptions = [];
      var allSelected = true;
      groups.forEach(function(grp) {
        var active = grp.querySelector('[data-comp-option-value].is-active');
        if (active) {
          selectedOptions.push(active.getAttribute('data-comp-option-value'));
        } else {
          allSelected = false;
        }
      });

      if (!allSelected) return;

      submittingCards[productId] = true;

      var variantsEl = card.querySelector('[data-comp-variants="' + productId + '"]');
      if (!variantsEl) return;

      var variants;
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (err) {
        return;
      }

      var matchedVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) {
          matchedVariant = v;
          break;
        }
      }

      if (!matchedVariant || !matchedVariant.available) {
        submittingCards[productId] = false;
        return;
      }

      var variantInput = card.querySelector('[data-comp-variant-id]');
      if (variantInput) variantInput.value = matchedVariant.id;

      var priceEl = card.querySelector('[data-comp-price]');
      if (priceEl && window.theme && window.theme.moneyFormat) {
        priceEl.textContent = theme.formatMoney(matchedVariant.price, theme.moneyFormat);
      }

      var formEl = variantInput ? variantInput.closest('form') : null;
      if (!formEl) return;

      var formData = new FormData(formEl);
      fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status) {
          submittingCards[productId] = false;
          return;
        }
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      })
      .catch(function() {
        submittingCards[productId] = false;
      });
    });
  }


  function initCartComplementaryDismiss() {
    var storageKey = 'dismissed_complementary';

    function getDismissed() {
      try {
        var data = sessionStorage.getItem(storageKey);
        return data ? JSON.parse(data) : {};
      } catch (e) {
        return {};
      }
    }

    function saveDismissed(map) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(map));
      } catch (e) {}
    }

    function hideDismissed() {
      var dismissed = getDismissed();
      var compIds = Object.keys(dismissed).reduce(function(arr, parentId) {
        return arr.concat(dismissed[parentId]);
      }, []);
      if (!compIds.length) return;
      compIds.forEach(function(id) {
        var items = document.querySelectorAll('[data-cart-complementary-item="' + id + '"]');
        items.forEach(function(item) {
          item.remove();
        });
      });
    }

    function pruneByCart() {
      fetch(window.theme.routes.cart_url + '.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var cartProductIds = {};
          cart.items.forEach(function(item) { cartProductIds[item.product_id] = true; });
          var dismissed = getDismissed();
          var changed = false;
          Object.keys(dismissed).forEach(function(parentId) {
            if (!cartProductIds[parentId]) {
              delete dismissed[parentId];
              changed = true;
            }
          });
          if (changed) saveDismissed(dismissed);
        });
    }

    hideDismissed();

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-cart-comp-dismiss]');
      if (!btn) return;
      var item = btn.closest('[data-cart-complementary-item]');
      if (item) {
        var compId = item.getAttribute('data-cart-complementary-item');
        var parentId = item.getAttribute('data-cart-comp-parent') || compId;
        var dismissed = getDismissed();
        if (!dismissed[parentId]) dismissed[parentId] = [];
        if (dismissed[parentId].indexOf(compId) === -1) {
          dismissed[parentId].push(compId);
          saveDismissed(dismissed);
        }
        item.remove();
      }
    });

    document.addEventListener('theme:cart:change', function() {
      pruneByCart();
      setTimeout(hideDismissed, 300);
    });
  }

  function init() {
    collectionListSlider();
    initHeaderState();
    sizeGuideUnitSwitcher();
    sizeGuideHideSwitcherIfEmpty();
    sizeGuideFixMobileScroll();
    fixMobileSliderTouch();
    siblingsOverflowToggle();
    quickAddSliderSync();
    klaviyoFormTrigger();
    observeCartItemLabel();
    initCartBarBehavior();
    cartUpsellRecommendations();
    observeBundleBarUpdates();
    fixFreeShippingLocalLimit();
    roundFreeShippingDisplay();
    removeOrphanedFreeGifts();
    anchorScrollLinks();
    siblingsLengthQuickAdd();
    siblingsLengthModal();
    siblingsLengthPreserveOptions();
    initCompOptionSliders();
    initCompVariantSelectors();
    initCartComplementaryDismiss();
  }

  /* Run URL option apply immediately — defer script means DOM is already parsed
     and theme.dev.js has already initialized product-form elements */
  siblingsLengthApplyUrlOptions();

  document.addEventListener('DOMContentLoaded', init);

})();
